<template>
    <modal name="document-folder-create-modal"
        :adaptive="true"
        :focusTrap="true"
        :width="500"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        @before-open="beforeOpen"
        @before-close="beforeClose"
    >
        <div class="rounded-lg bg-white p-6">
            <div class="flex flex-col mb-6">
                <div class="h-4 flex items-center justify-between leading-none mb-3">
                    <label class="uppercase text-gray-700 text-xs tracking-wider leading-none">
                        Folder Name
                    </label>
                </div>

                <input type="folder_name"
                    class="flex-1 field text-base"
                    name="folder_name"
                    v-model="folder_name"
                    @keyup.enter="createFolder"
                >
            </div>

            <div v-if="error" class="text-red-600 font-semibold text-sm leading-tight mb-0">
                {{ error }}
            </div>

            <div class="flex items-center justify-end pt-4">
                <button type="button"
                    class="flex-none uppercase tracking-widest bg-white border border-gray-400 hover:bg-gray-200 text-gray-500 text-sm hover:text-gray-600 px-7 py-2 mr-4"
                    @click="beforeClose"
                >
                    Cancel
                </button>

                <button type="button"
                    class="flex-none uppercase tracking-widest border border-green-warm-600 bg-green-warm-600 hover:bg-green-warm-500 text-white text-sm hover:text-white px-7 py-2"
                    @click="createFolder"
                >
                    Create
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        show: {},
        property_id: {},
    },

    data() {
        return {
            folder_name: null,
            error: null,
        }
    },

    methods: {
        beforeOpen(event) {
            this.folder_name = '';
        },
        beforeClose(event) {
            this.$emit('closed');
        },
        createFolder() {
            if (! this.folder_name) {
                this.error = 'Please enter a folder name.';
                return;
            }

            this.error = null;

            axios.post('/properties/' + this.property_id + '/document-folders/', {
                name: this.folder_name,
            }).then(response => {
                this.$emit('createdFolder', response.data);
                this.$modal.hide('document-folder-create-modal');
            }).catch(error => {
                this.error = error.response.data.message;
                console.log(error.response);
            });
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.$modal.show('document-folder-create-modal');
            } else {
                this.$modal.hide('document-folder-create-modal');
            }
        },
    },
}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
